import { useState } from "react";

import { Container, NavDropdown, Row } from "react-bootstrap";

import MegaMenuItem from "./megamenu-item";
import { MenuItemProps } from "./navigation.config";

type MegaMenuProps = {
  item: MenuItemProps;
  pathname: string;
  handleClose: () => void;
};

export default function MegaMenu({ item, pathname, handleClose }: MegaMenuProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleMegaMenuClose = () => {
    handleClose();
    setDropdownOpen(false);
  };

  return (
    <NavDropdown
      title={item.label}
      className={`mega-menu${pathname.includes(item.url) ? " active" : ""}`}
      show={dropdownOpen}
      onToggle={(isOpen) => setDropdownOpen(isOpen)}
    >
      <Container className="py-5 mega-menu border-top">
        <Row>
          {item.items?.map((subItem) => (
            <MegaMenuItem
              key={subItem.id}
              subItem={subItem}
              active={subItem.url === pathname}
              handleClose={handleMegaMenuClose}
            />
          ))}
        </Row>
      </Container>
    </NavDropdown>
  );
}
